<template>
    <v-dialog :model-value="show" persistent max-width="440px">
        <v-card>
            <v-card-title>
                <span v-if="step === 'delivered'" class="text-center">Êtes-vous sûr de cette action</span>
                <span v-else>Informations</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row justify="center">
                        <!-- Date de retrait -->
                        <v-col v-if="step == 'printed'" cols="12">
                            <p class="text-subtitle-1 font-weight-medium mb-1">
                                Date de retrait <span style="color: red !important">*</span>
                            </p>
                            <v-text-field
                                type="date"
                                variant="outlined"
                                density="compact"
                                prepend-inner-icon="mdi-calendar-clock-outline"
                                v-model="fields.appointment_date"
                                :error-messages="errors.appointment_date"
                            />
                        </v-col>

                        <!-- Référence du diplôme -->
                        <v-col v-if="step == 'printed'" cols="12">
                            <p class="text-subtitle-1 font-weight-medium mb-1">
                                Référence du diplôme <span style="color: red !important">*</span>
                            </p>
                            <v-text-field
                                required
                                variant="outlined"
                                density="compact"
                                clearable
                                placeholder="Ex: 0021423"
                                v-model="fields.reference_diplome"
                                :error-messages="errors.reference_diplome"
                            />
                        </v-col>

                        <!-- Motif du rejet -->
                        <v-col v-if="step == 'rejected'" cols="12">
                            <p class="text-subtitle-1 font-weight-medium mb-2">
                                Motif du rejet <span class="text-caption">(optionel)</span>
                            </p>
                            <quill-editor
                                v-model:content="fields.motif_rejet"
                                content-type="html"
                                theme="snow"
                                placeholder="Description"
                                style="min-height: 120px"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn size="large" color="red-darken-1" variant="text" @click="cancelAction()"> Annuler </v-btn>
                <v-btn
                    :loading="isLoading"
                    :disabled="isLoading"
                    color="indigo-darken-1"
                    variant="text"
                    @click="save"
                >
                    Continuer
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { putIndivAction } from '../../functions/request_utils/putIndivAction';

export default {
    name: 'DemandeIndivActionDialog',
    components: { QuillEditor },
    props: {
        show: { type: Boolean, default: false },
        step: { type: String, required: true },
        demandeId: { type: String, required: true },
        isLoading: { type: Boolean, default: true }
    },
    emits: ['cancel', 'done', 'handleLoading'],
    data: () => ({
        fields: {
            appointment_date: null,
            reference_diplome: '',
            observation: '',
            motif_rejet: ''
        },
        errors: {
            appointment_date: null,
            reference_diplome: '',
            observation: '',
            motif_rejet: ''
        }
    }),
    methods: {
        cancelAction() {
            for (const key of Object.keys(this.fields)) {
                this.fields[key] = '';
            }
            for (const key of Object.keys(this.errors)) {
                this.errors[key] = '';
            }
            this.$emit('cancel');
        },
        save() {
            switch (this.step) {
                case 'printed':
                    this.print();
                    break;
                case 'delivered':
                    this.delivered();
                    break;
                case 'rejected':
                    this.reject();
                    break;
            }
        },
        async print() {
            this.loadOn();
            try {
                await putIndivAction(this.demandeId, {
                    step: this.step,
                    appointment_date: this.fields.appointment_date,
                    reference_diplome: this.fields.reference_diplome
                });
                this.$emit('done');
            } catch (err) {
                this.$swal.fire({ title: 'Erreur', text: err.message ?? 'Erreur sur le serveur', icon: 'error' });
                if (err.errors != undefined) {
                    Object.keys(err.errors).forEach((key) => {
                        this.errors[key] = err.errors[key][0];
                    });
                }
            } finally {
                this.loadOff();
            }
        },
        async reject() {
            this.loadOn();
            try {
                await putIndivAction(this.demandeId, { step: this.step, motif_rejet: this.fields.motif_rejet });
                this.$emit('done');
            } catch (err) {
                this.$swal.fire({ title: 'Erreur', text: err.message ?? 'Erreur sur le serveur', icon: 'error' });
                if (err.errors != undefined) {
                    Object.keys(err.errors).forEach((key) => {
                        this.errors[key] = err.errors[key][0];
                    });
                }
            } finally {
                this.loadOff();
            }
        },
        async delivered() {
            this.loadOn();
            try {
                await putIndivAction(this.demandeId, { step: this.step });
                this.$emit('done');
            } catch (err) {
                this.$swal.fire({ title: 'Erreur', text: err.message ?? 'Erreur sur le serveur', icon: 'error' });
                if (err.errors != undefined) {
                    Object.keys(err.errors).forEach((key) => {
                        this.errors[key] = err.errors[key][0];
                    });
                }
            } finally {
                this.loadOff();
            }
        },
        loadOn() {
            this.$emit('handleLoading', true);
        },

        loadOff() {
            this.$emit('handleLoading', false);
        }
    }
};
</script>
